module.exports = __webpack_public_path__ + "static/CircularPro-MediumItalic.c45c4702.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-MediumItalic.ttf
// module id = 733
// module chunks = 168707334958949